import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import Tooltip, { POSITION } from 'gnos-tooltip'

import Minireport from '../../../../../../../../../../components/Minireport'

import './style.scss'

export default class TrGroupComponent extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        entity: IPropTypes.record,
    }

    render() {
        const { children, entity } = this.props

        if (!entity) {
            return (
                <div className={'group-content-table-custom-row'}>
                    <div className={'content-wrapper'}>{children}</div>
                </div>
            )
        }

        const minireport = <Minireport id={entity.get('entId', null)} />

        return (
            <Tooltip
                content={minireport}
                id={`group-stack-table-entity-minireport-tooltip-${entity.get('entId')}`}
                position={POSITION.RIGHT}
                showDelay={1000}
                width={'320px'}
                automaticAlignChange
                doubleWrap
            >
                <div className={'group-content-table-custom-row'}>
                    <div className={'content-wrapper'}>{children}</div>
                </div>
            </Tooltip>
        )
    }
}
